import { useEffect } from "react";

// Closes a menu / popover when the user mousedowns outside any element that
// carries `[data-<attr>]`. Toggled by `active` so the listener is only
// attached while the menu is open.
export function useClickOutsideAttr(attr, active, onOutside) {
  useEffect(() => {
    if (!active) return;
    const onDoc = (e) => {
      if (!e.target.closest(`[${attr}]`)) onOutside();
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [attr, active, onOutside]);
}
